import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tag, Table } from 'antd';
import { Lightbulb, Eye } from 'lucide-react';
import dayjs from 'dayjs';
import { StatusTag, IconAction, IconActions, EmptyState, CollapsibleCard } from '../../../common';
import TradeStatusTag from './tradeStatus';

const CAMPAIGN_TYPE_MAP = {
    pop_blando: { label: 'POP Blando', color: 'orange' },
    pop_duro: { label: 'POP Duro', color: 'gold' }
};

const formatDate = (date) => <span className="text-sm text-surface-600 tabular-nums">{date ? dayjs(date).format('DD/MM/YYYY') : '—'}</span>;

export default function StoreCampaignsSection({ campaigns }) {
    const navigate = useNavigate();
    const safeCampaigns = Array.isArray(campaigns) ? campaigns : [];

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <span className="text-sm font-medium text-surface-900">{text}</span>
        },
        {
            title: 'Tipo',
            dataIndex: 'campaignType',
            key: 'campaignType',
            render: (type) => {
                const t = CAMPAIGN_TYPE_MAP[type] || { label: type, color: 'default' };
                return <Tag color={t.color}>{t.label}</Tag>;
            }
        },
        {
            title: 'Inicio',
            dataIndex: 'startDate',
            key: 'startDate',
            render: formatDate
        },
        {
            title: 'Vencimiento',
            dataIndex: 'expirationDate',
            key: 'expirationDate',
            render: formatDate
        },
        {
            title: 'Estado',
            key: 'status',
            render: (_, record) => <TradeStatusTag record={record} />
        },
        {
            title: '',
            key: 'action',
            width: 64,
            align: 'right',
            render: (_, record) => (
                <IconActions>
                    <IconAction icon={<Eye />} label="Ver" onClick={() => navigate(`/dashboard/trade/campaigns/campaign?id=${record._id}`)} />
                </IconActions>
            )
        }
    ];

    return (
        <CollapsibleCard
            title="Campañas"
            icon={<Lightbulb />}
            iconTone="warning"
            flush={safeCampaigns.length > 0}
            badges={
                <StatusTag tone="neutral">
                    {safeCampaigns.length} {safeCampaigns.length === 1 ? 'campaña' : 'campañas'}
                </StatusTag>
            }>
            {safeCampaigns.length > 0 ? (
                <Table dataSource={safeCampaigns} columns={columns} rowKey="_id" pagination={false} size="middle" scroll={{ x: 'max-content' }} />
            ) : (
                <EmptyState icon={<Lightbulb />} title="Sin campañas" description="No hay campañas activas para este PDV" />
            )}
        </CollapsibleCard>
    );
}
